export class Util {

    public currentUser = JSON.parse(localStorage.getItem('currentUser') ?? 'null') ?? {};
    
    public Permisos = JSON.parse(localStorage.getItem("permisos")||"{}")

}
